module.exports = __webpack_public_path__ + "media/images/powerpoint/ferpection-background-a072ddbee3c6fcd45c47a15a79ee9c45.png";